import { useQuery } from "@tanstack/react-query";
import { referralsService } from "@/services/referralsService";
import type { ReferralEarningFilterParams } from "@/types/referral.dto";
import { flattenReferralNetwork, mapReferralEarningsToRows } from "@/lib/mappers/account-mappers";
import { queryKeys } from "./keys";

export function useReferralSummary() {
  return useQuery({
    queryKey: queryKeys.referrals.summary,
    queryFn: () => referralsService.getSummary(),
  });
}

export function useReferralLink(storeId?: number) {
  return useQuery({
    queryKey: [...queryKeys.referrals.link, storeId ?? "user"],
    queryFn: () => referralsService.getMyLink(storeId),
  });
}

export function useReferralNetwork(maxLevel = 5) {
  return useQuery({
    queryKey: queryKeys.referrals.network(maxLevel),
    queryFn: async () => {
      const network = await referralsService.getNetwork(maxLevel);
      return flattenReferralNetwork(network);
    },
  });
}

export function useReferralEarnings(filter: ReferralEarningFilterParams = { pageSize: 50 }) {
  return useQuery({
    queryKey: queryKeys.referrals.earnings(filter),
    queryFn: async () => {
      const result = await referralsService.getEarnings(filter);
      return {
        ...result,
        items: mapReferralEarningsToRows(result.items),
      };
    },
  });
}
